import { LOCAL_STORAGE_AUTH, LOCAL_STORAGE_LOGIN } from "./consts.api";

const saveLogin = login => localStorage.setItem(LOCAL_STORAGE_LOGIN, login);

const userName = () => localStorage.getItem(LOCAL_STORAGE_LOGIN) || "";

const authorizationSave = auth =>
  localStorage.setItem(LOCAL_STORAGE_AUTH, JSON.stringify(auth));

const authorizationDelete = () => {
  if (localStorage.getItem(LOCAL_STORAGE_AUTH)) {
    localStorage.removeItem(LOCAL_STORAGE_AUTH);
  }
};

const authorizationGet = () => {
  return localStorage.getItem(LOCAL_STORAGE_AUTH)
    ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_AUTH))
    : null;
};

export {
  saveLogin,
  userName,
  authorizationSave,
  authorizationDelete,
  authorizationGet
};
